import React, { useEffect, useRef, useState } from "react";
import {
  Editor,
  EditorState,
  RichUtils,
  convertToRaw,
  convertFromRaw,
} from "draft-js";
import "./DraftEditor.css";
import Toolbar from "./ToolBar";
import Switch from '@mui/material/Switch';
import { makeStyles } from "../../../../node_modules/@mui/styles/index";
import clsx from 'clsx';
import { Tooltip } from "../../../../node_modules/@mui/material/index";

const useStyle = makeStyles(() => ({
  editorContainer: (props) => ({
    backgroundColor: "#fff",
    width: "100% !important",
    padding: "1rem",
    height: "90%",
    overflowY: "auto",
    fontSize: "16px",
    // background: 'transparent',
    transition: 'background 0.3s ease',
    border: props.readOnly ? "none" : "1px solid #ddd", // Dynamically set the border
  }),
    editorContainerPunchOut: (props) => ({
    backgroundColor: "#fff",
    position:"relative",
    right:"60px",
    width: "calc(100% + 120px) !important",
    padding: "1rem",
    height: "90%",
    overflowY: "auto",
    fontSize: "16px",
    // background: 'transparent',
    transition: 'background 0.3s ease',
    border: props.readOnly ? "none" : "1px solid #ddd", // Dynamically set the border
  }),
  hasText: {
    background: '#F9F9F9 !important',
  },
}))
const DraftEditor = ({
  notes = null,
  setDraft,
  readOnly = false,
  setIsreadOnly,
  switchStatus = true,
  display = true,
  component
}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty()); // Initialize with an empty editor state
  // const editor = useRef(null);

  useEffect(() => {
    if (notes !== null) {
      focusEditor();
    }
  }, []);

  const focusEditor = () => {
    // editor.current.focus();
  };


  const classes = useStyle({readOnly});


  //             DONT DELETE BELOW COMMENTS AND LOGS

  // useEffect(() => {
  //   console.log('notes in useEffect----> ' , notes);
  //   if (notes !== null) {

  //     const contentState = convertFromRaw(JSON.parse(notes ?? notes?.blocks));
  //     // console.log('notes in useEffect----> ' , contentState);
  //     //  console.log(contentState);
  //     // const contentState =  convertFromRaw(notes);
  //     console.log(contentState);
  //       setEditorState(EditorState.createWithContent(contentState));
  //     }
  //   }, [notes]);

  // useEffect(() => {
  //   if (notes !== null) {
  //     let contentState;
  //     if (typeof notes === 'string') {
  //       contentState = convertFromRaw(JSON.parse(notes ?? notes?.blocks));
  //     } else if(typeof notes === 'object') {
  //       contentState = convertFromRaw(notes);
  //     } else {
  //       contentState = convertFromRaw(JSON.parse(notes ?? notes?.blocks));
  //     }
  //     setEditorState(EditorState.createWithContent(contentState));
  //   }
  // }, [notes]);

  // var notesTest = `{"blocks":[{"key":"24g34","text":"this is pharmsamer","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}} `

  // var notesNewTest = `"{\"blocks\":[{\"key\":\"csdb7\",\"text\":\"gdfgdfgd\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}"`

  // const noteclean = `{"blocks":[{"key":"csdb7","text":"gdfgdfgd","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`

  useEffect(() => {
    if (notes !== null) {
      let contentState;
      if (typeof notes === "string") {
        const match = notes.match(/\\\"blocks\\\"/);
        if (match) {
          const cleanNotes = notes.replace(/\\/g, "").slice(1, -1);
          contentState = convertFromRaw(JSON.parse(cleanNotes));
        } else {
          contentState = convertFromRaw(JSON.parse(notes));
        }
      } else if (typeof notes === "object") {
        contentState = convertFromRaw(notes);
      } else {
        contentState = convertFromRaw(notes);
      }
      setEditorState(EditorState.createWithContent(contentState));
    }
  }, [notes]);

  const handleKeyCommand = (command) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      setEditorState(newState);
      return true;
    }
    return false;
  };

  // FOR INLINE STYLES
  const styleMap = {
    CODE: {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
      fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
      fontSize: 16,
      padding: 2,
    },
    HIGHLIGHT: {
      backgroundColor: "#F7A5F7",
    },
    UPPERCASE: {
      textTransform: "uppercase",
    },
    LOWERCASE: {
      textTransform: "lowercase",
    },
    CODEBLOCK: {
      fontFamily: '"fira-code", "monospace"',
      fontSize: "inherit",
      background: "#ffeff0",
      fontStyle: "italic",
      lineHeight: 1.5,
      padding: "0.3rem 0.5rem",
      borderRadius: " 0.2rem",
    },
    SUPERSCRIPT: {
      verticalAlign: "super",
      fontSize: "80%",
    },
    SUBSCRIPT: {
      verticalAlign: "sub",
      fontSize: "80%",
    },
  };

  // FOR BLOCK LEVEL STYLES(Returns CSS Class From DraftEditor.css)
  const myBlockStyleFn = (contentBlock) => {
    const type = contentBlock.getType();
    switch (type) {
      case "blockQuote":
        return "superFancyBlockquote";
      case "leftAlign":
        return "leftAlign";
      case "rightAlign":
        return "rightAlign";
      case "centerAlign":
        return "centerAlign";
      case "justifyAlign":
        return "justifyAlign";
      default:
        break;
    }
  };

  return (
    <div className="editor-wrapper" onClick={focusEditor}
    >
      <div style={{ display: "flex" }}>
        {!readOnly && !component && (
          <Toolbar editorState={editorState} setEditorState={setEditorState} />
        )}
        <div
          style={{ display: switchStatus ? "flex" : "none", marginLeft: "auto", width: "max-content" }}
        >
          {display === true && !component && (
            <Tooltip title={readOnly ? "Show Menu" : "Hide Menu"} arrow>
              <Switch
                defaultChecked={false}
                onChange={(event, newValue) => setIsreadOnly(newValue)}
                checked={readOnly}
              />
            </Tooltip>
          )}
        </div>
      </div>
      {/* <div className={classes.editorContainer}>
        <Editor
          // ref={editor}
          placeholder={readOnly ? '' : "Type something..."}
          readOnly={readOnly}
          handleKeyCommand={handleKeyCommand}
          editorState={editorState}
          customStyleMap={styleMap}
          blockStyleFn={myBlockStyleFn}
          onChange={(editorState) => {
            const contentState = editorState.getCurrentContent();
            setDraft(convertToRaw(contentState));
            setEditorState(editorState);
          }}
        />
      </div> */}
      <div
      className={!component ? clsx(classes.editorContainer, {
        [classes.hasText]: editorState.getCurrentContent().hasText(),
      }) : 
      clsx(classes.editorContainerPunchOut, {
        [classes.hasText]: editorState.getCurrentContent().hasText(),
      }) 
      }
    >
  <Editor
    placeholder={readOnly ? '' : !component ? "Type something..." : "Please summarize your work before checking out."}
    readOnly={readOnly}
    handleKeyCommand={handleKeyCommand}
    editorState={editorState}
    customStyleMap={styleMap}
    blockStyleFn={myBlockStyleFn}
    onChange={(editorState) => {
      const contentState = editorState.getCurrentContent();
      const plainText = contentState.getPlainText();
      setDraft(convertToRaw(contentState));
      setEditorState(editorState);
    }}
  />
</div>
    </div>
  );
};

export default DraftEditor;
